import type { AppTopbarRef, ColorScheme } from "@/types";
import { Button } from "primereact/button";
import { PrimeReactContext } from "primereact/api";
import { OverlayPanel } from 'primereact/overlaypanel';
import { InputText } from "primereact/inputtext";
import { forwardRef, useContext, useImperativeHandle, useRef, useEffect } from "react";
import AppBreadcrumb from "./AppBreadCrumb";
import { LayoutContext } from "./context/layoutcontext";
import { RadioButton, RadioButtonChangeEvent } from "primereact/radiobutton";
import {logoutUser} from '../../reducers/authentications/authenticationsSlice'
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "src/store";

const AppTopbar = forwardRef<AppTopbarRef>((props, ref) => {
    const dispatch = useDispatch<AppDispatch>()
    const token = useSelector((state: RootState) => state.authentications.user.token);
    const { changeTheme } = useContext(PrimeReactContext);
    const { onMenuToggle, showProfileSidebar, showConfigSidebar, layoutConfig, setLayoutConfig } =
        useContext(LayoutContext);
    const menubuttonRef = useRef(null);
    const themeSettingsRef = useRef<OverlayPanel>(null);
    const logoutRef = useRef<OverlayPanel>(null);

    const changeColorScheme = (colorScheme: ColorScheme) => {
        changeTheme?.(
            layoutConfig.colorScheme,
            colorScheme,
            "theme-link",
            () => {
                setLayoutConfig((prevState) => ({ ...prevState, colorScheme }));
                localStorage.setItem("colorScheme", colorScheme)
            }
        );
    };



    const onConfigButtonClick = () => {
        showConfigSidebar();
    };

    useImperativeHandle(ref, () => ({
        menubutton: menubuttonRef.current,
    }));

    return (
        <div className="layout-topbar">
            <div className="topbar-start">
                <button
                    ref={menubuttonRef}
                    type="button"
                    className="topbar-menubutton p-link p-trigger"
                    onClick={onMenuToggle}
                >
                    <i className="pi pi-bars"></i>
                </button>

                <AppBreadcrumb className="topbar-breadcrumb"></AppBreadcrumb>
            </div>

            <div className="topbar-end">
                <ul className="topbar-menu">
                    <li className="topbar-search">
                        <span className="p-input-icon-left">
                            <i className="pi pi-search"></i>
                            <InputText
                                type="text"
                                placeholder="Search"
                                className="w-12rem sm:w-full"
                            />
                        </span>
                    </li>
                    <li className="ml-3">
                        <Button
                            type="button"
                            icon="pi pi-palette fs-large"
                            text
                            rounded
                            severity="secondary"
                            className="flex-shrink-0"
                            onClick={(e) => themeSettingsRef?.current?.toggle(e)}
                        ></Button>
                        <OverlayPanel ref={themeSettingsRef}>
                          <div className="flex">
                              <div className="field-radiobutton pr-3">
                                  <RadioButton
                                      name="colorScheme"
                                      value="light"
                                      checked={layoutConfig.colorScheme === "light"}
                                      onChange={(e: RadioButtonChangeEvent) => changeColorScheme(e.value)}
                                      inputId="mode-light"
                                  />
                                  <label htmlFor="mode-light">Light</label>
                              </div>
                              <div className="field-radiobutton pr-3">
                                  <RadioButton
                                      name="colorScheme"
                                      value="dim"
                                      checked={layoutConfig.colorScheme === "dim"}
                                      onChange={(e: RadioButtonChangeEvent) => changeColorScheme(e.value)}
                                      inputId="mode-dim"
                                  />
                                  <label htmlFor="mode-dim">Dim</label>
                              </div>
                              <div className="field-radiobutton">
                                  <RadioButton
                                      name="colorScheme"
                                      value="dark"
                                      checked={layoutConfig.colorScheme === "dark"}
                                      onChange={(e: RadioButtonChangeEvent) => changeColorScheme(e.value)}
                                      inputId="mode-dark"
                                  />
                                  <label htmlFor="mode-dark">Dark</label>
                              </div>


                          </div>
                        </OverlayPanel>
                    </li>
                    <li className="ml-3">
                        <Button
                            type="button"
                            icon="pi pi-power-off fs-large"
                            text
                            rounded
                            severity="secondary"
                            className="flex-shrink-0"
                            onClick={(e) => logoutRef?.current?.toggle(e)}
                        ></Button>
                        <OverlayPanel ref={logoutRef}>
                          <div className="flex">
                          <Button
                              type="button"
                              icon="pi pi-power-off fs-large"
                              text
                              label="Sign Out"
                              // rounded
                              severity="secondary"
                              // className="flex-shrink-0"
                              onClick={() => dispatch(logoutUser({token}))}
                          ></Button>

                          </div>
                        </OverlayPanel>
                    </li>

                    <li className="topbar-profile">
                        <button
                            type="button"
                            className="p-link"
                            onClick={showProfileSidebar}
                        >
                            <img
                                src="/layout/images/avatar/avatar.png"
                                alt="Profile"
                            />
                        </button>
                    </li>
                </ul>
            </div>
        </div>
    );
});

AppTopbar.displayName = "AppTopbar";

export default AppTopbar;

// <OverlayPanel ref={themeSettingsRef}>
//   <div className="flex">
//       <div className="flex align-items-center">
//           <RadioButton id="light" name="darkMenu" value="light" checked={props.colorMode === 'light'} onChange={(e)=>changeTheme(e, '111010')} />
//           <label htmlFor="light" className={classNames({ 'ml-2': !isRTL, 'mr-2': isRTL })}>
//               Light
//           </label>
//       </div>
//       <div className={classNames('flex align-items-center', { 'ml-4': !isRTL, 'mr-4': isRTL })}>
//           <RadioButton id="dark" name="darkMenu" value="dark" checked={props.colorMode === 'dark'} onChange={(e) =>changeTheme(e, 'f7f3f3')} />
//           <label htmlFor="dark" className={classNames({ 'ml-2': !isRTL, 'mr-2': isRTL })}>
//               Dark
//           </label>
//       </div>
//   </div>
// </OverlayPanel>
